// we import all of the colors that already come with vuetify
// please reference https://vuetifyjs.com/en/style/colors for list of colors available
import colors from 'vuetify/es5/util/colors'
// here we define any of our own custom colors
const customColors = {
  appyColor: {
    pink: '#f92e74',
    lightPink: '#d8b7c0',
    gold: '#b2a584'
  }
}
// We merge vuetify colors with our own
const appyColors = {...colors, ...customColors}
export default appyColors

// Here we define colors for any component types / feature ...etc
export const featureColors = {
  // general colors used across the theme and website
  general: {
    primary: appyColors.grey.darken4, // #212121
    secondary: appyColors.grey.lighten2, // #E0E0E0
    accent: appyColors.grey.darken3, // #424242
    error: appyColors.deepOrange.darken1, // #F4511E
    warning: appyColors.amber.accent3, // #FFC400
    info: appyColors.grey.darken3, // #424242
    success: appyColors.lightGreen.accent3 // #76FF03
  },
  // Specific component / feature colors
  // CARDS
  cards: {
    cardBackground: appyColors.shades.white, // #FFFFFF
    cardText: appyColors.grey.darken4 // #212121
  },
  // NAVIGATION
  navigation: {
    primaryButtonText: appyColors.shades.white,
    primaryButtonBackground: appyColors.grey.darken4
  }
}
